import React from 'react';
import {
  string,
  arrayOf,
  shape,
} from 'prop-types';
import _ from 'lodash';
import { HtmlParser, Small } from 'components/common';
import AccordionSubSection from './AccordionSubSection';
import './Offer.scss';

const renderRewardTandC = (reward, index) => (
  // TODO: need to gen key
  // eslint-disable-next-line react/no-array-index-key
  <HtmlParser key={index} htmlString={_.get(reward, 'tandc.longDescrition')} />
);

const renderOptionLabel = (label, index) => (
  <div>
    <Small primary>
      <strong>{`${label} ${index}`}</strong>
    </Small>
  </div>
);

const Offer = (props) => {
  const {
    title,
    reward,
    labelOption,
  } = props;

  const offerCount = reward.length;

  return (
    <AccordionSubSection
      title={title}
    >
      {reward.map((val, index) => (
        // eslint-disable-next-line
        <div className="offer" key={index}>
          {offerCount > 1 ? renderOptionLabel(labelOption, index + 1) : null}
          <div>
            <strong>
              {val.title}
            </strong>
          </div>
          <div>
            {renderRewardTandC(val, index)}
          </div>
          {(offerCount > 1 && index !== reward.length - 1) ? <hr className="offerSeparator" /> : null}
        </div>
      ))}
    </AccordionSubSection>
  );
};

Offer.defaultProps = {
  reward: null,
  labelOption: null,
};

Offer.propTypes = {
  title: string.isRequired,
  reward: arrayOf(shape({})),
  labelOption: string,
};

export default Offer;
